import React, { Suspense } from 'react';
import ewtStore from '../EWTStore';
import { observer } from "mobx-react"
import Leaderboard from './Leaderboard';
import Scoring from './Scoring';
import PlayerCard from './PlayerCard';
import CourseCard from './CourseCard';
import CorrectScore from './CorrectScore';
import RoundMaint from './RoundMaint';
import Pairings from './Pairings';
import Players from './Players';
import {Dropdown,Modal} from 'antd';
import '../App.css';
import {CommentOutlined,CompassFilled,CameraOutlined,TrophyOutlined,EditOutlined,MenuOutlined,EditFilled,PlusOutlined,SyncOutlined} from '@ant-design/icons';
import RoundSelector from './RoundSelector';
import dayjs from '../dayjs';
import { theme, ewtModalClass, modalStyle } from '../theme';
import { Itinerary } from './Itinerary';
import { DataTournamentEdit } from './DataTournamentEdit';
import { PlayerDetails } from './PlayerDetails';

const Setup = React.lazy(() => import('./Setup'));
const PlayerPhoto = React.lazy(() => import('./PlayerPhoto'));
const Chat = React.lazy(() => import('./Chat'));

const MainView = observer(class MainView extends React.Component {
    state = {
		courseCardRoundID:'',
		showTournamentEdit: false,
		selectedTournament: null,
    };

    componentDidMount() {
		this.handleViewportChange = this.handleViewportChange.bind(this);
		window.addEventListener('resize', this.handleViewportChange);
		if (window.visualViewport) {
			window.visualViewport.addEventListener('resize', this.handleViewportChange);
			window.visualViewport.addEventListener('scroll', this.handleViewportChange);
		}
		this.handleViewportChange();
		if (!ewtStore.showView) {
			ewtStore.showView = "MV";
		}
		this.setState({current:ewtStore.currentView});
		this.roundChanged = this.roundChanged.bind(this);
		if (typeof window.history.pushState === "function") {
			window.history.pushState("jibberish", null, null);
			window.window.onpopstate = function () {
				if (ewtStore.showPlayerCard) ewtStore.showPlayerCard = false;
				if (ewtStore.showCourseCard) ewtStore.showCourseCard = false;
				if (ewtStore.showTieBreaker) ewtStore.showTieBreaker = false;
				if (ewtStore.showCourseMap) ewtStore.showCourseMap = false;
				if (ewtStore.correctScore) ewtStore.correctScore = null;
				if (ewtStore.showFullPic) ewtStore.showFullPic = null;
				if (ewtStore.showHole) ewtStore.showHole = null;
				if (ewtStore.showPairings) ewtStore.showPairings = false;
				if (ewtStore.showPlayers) ewtStore.showPlayers = false;
				window.history.pushState('newjibberish', null, null);
				// Handle the back (or forward) buttons here
				// Will NOT handle refresh, use onbeforeunload for this.
			};
		}
		else {
			var ignoreHashChange = true;
			window.onhashchange = function () {
				if (!ignoreHashChange) {
					ignoreHashChange = true;
					console.log("backish")
					window.location.hash = Math.random();
					// Detect and redirect change here
					// Works in older FF and IE9
					// * it does mess with your hash symbol (anchor?) pound sign
					// delimiter on the end of the URL
				}
				else {
					ignoreHashChange = false;   
				}
			};
		}
	}

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleViewportChange);
		if (window.visualViewport) {
			window.visualViewport.removeEventListener('resize', this.handleViewportChange);
			window.visualViewport.removeEventListener('scroll', this.handleViewportChange);
		}
    }

    handleViewportChange = () => {
		if (ewtStore.usingKeyboard) {
			if (dayjs().diff(ewtStore.usingKeyboardStart) > 200) {
				if (ewtStore.usingKeyboard.current) ewtStore.usingKeyboard.current.blur();
			}
			return;
		}
		ewtStore.syncViewportSize();
    };

	handleClick = e => {
		ewtStore.currentView = e.key;
		this.setState({current:e.key})
	  };

	  roundChanged(roundID) {
		this.setState({ courseCardRoundID: roundID });
		ewtStore.ensureRoundScoresLoaded(roundID);
		const round = ewtStore.rounds && ewtStore.rounds[roundID];
		if (round && round.courseID) {
			ewtStore.ensureCourse(round.courseID);
		}
	}

	openAddTournament = () => {
		this.setState({ showTournamentEdit: true, selectedTournament: null });
	}

	openEditTournament = (tournament) => {
		this.setState({ showTournamentEdit: true, selectedTournament: tournament });
	}

	closeTournamentEdit = () => {
		this.setState({ showTournamentEdit: false, selectedTournament: null });
	}

	render() {
		const isWide = ewtStore.windowWidth > 600;
		const shellWidth = isWide
			? (ewtStore.panelWidth || 400) + 12
			: '100%';
		const itemStyle = { fontSize: 26, padding: 10 };
		const menuItems = [];
		if (ewtStore.initialized && ewtStore.tournament) {
			menuItems.push({ key: 'pairings', label: 'Pairings', style: itemStyle });
		}
		if (ewtStore.initialized) {
			menuItems.push({ key: 'players', label: 'Players', style: itemStyle });
		}
		if (ewtStore.initialized && ewtStore.rounds) {
			menuItems.push({ key: 'itinerary', label: 'Weekend Schedule', style: itemStyle });
		}
		if (ewtStore.initialized && ewtStore.currentRoundID) {
			menuItems.push({ key: 'tiebreaker', label: 'Tie Breaker', style: itemStyle });
		}
		if (!ewtStore.fanMode) {
			menuItems.push({ key: 'photo', label: 'Player Photo', style: itemStyle });
		}
		if (ewtStore.initialized) {
			menuItems.push({ key: 'tournament', label: 'Select Tournament', style: itemStyle });
		}
		if (ewtStore.player && ewtStore.player.admin && ewtStore.tournament && ewtStore.rounds) {
			menuItems.push({ key: 'editrounds', label: 'Edit Rounds', style: itemStyle });
		}
		menuItems.push({ key: 'player', label: 'Log Out', style: itemStyle });
		const handleMainMenuClick = ({ key }) => {
			switch (key) {
				case 'pairings':
					ewtStore.showPairings = true;
					break;
				case 'players':
					ewtStore.showPlayers = true;
					break;
				case 'itinerary':
					ewtStore.showItinerary = true;
					break;
				case 'tiebreaker':
					ewtStore.showTieBreaker = true;
					break;
				case 'photo':
					ewtStore.gallery = false;
					ewtStore.showView = 'photo';
					break;
				case 'tournament':
					ewtStore.showPlayerCard = null;
					ewtStore.selectTournament = true;
					if (ewtStore.fanMode) {
						ewtStore.loadFanTournaments();
					} else {
						ewtStore.loadAllTournaments();
					}
					break;
				case 'player':
					ewtStore.logOut();
					break;
				case 'editrounds':
					ewtStore.editRounds = true;
					break;
				default:
					break;
			}
		};
		  
		return (
		<div className="appViewport">
		<div className="flexColumn appShell" style={{ width: shellWidth, maxWidth: '100%', flexGrow: 0, boxSizing: 'border-box' }}>
				<div className="flexColumn appShellMain">
					<div className="flexRow appHeader" style={{ width: '100%', minWidth: 0, fontSize: 16, color: theme.navy, padding: '6px 8px', alignItems: 'center', overflow: 'hidden' }}>
						<div className="flexGrow noselect flexRow appHeaderBrand" style={{ minWidth: 0, fontSize: 26, textAlign: 'center', cursor: 'pointer', alignItems: 'center' }}>
							<div className="flexRow appHeaderCompass" style={{ color: theme.brandBlue }} onClick={() => {if (ewtStore.course) ewtStore.showCourseMap = true}}><CompassFilled/></div>
							<div className="flexRow appHeaderTitle" onClick={() => {
								if (!ewtStore.initialized) return;
								const roundID = ewtStore.currentRoundID || '';
								if (roundID) {
									ewtStore.ensureRoundScoresLoaded(roundID);
									const round = ewtStore.rounds && ewtStore.rounds[roundID];
									if (round && round.courseID) {
										ewtStore.ensureCourse(round.courseID);
									}
								}
								ewtStore.showCourseCard = true;
							}}>
								<img src={ewtStore.logoURL} alt="" className="appHeaderLogo" />
								{ewtStore.tournament && (
									<span style={{ color: theme.slate, fontWeight: 400, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{ewtStore.tournament.name}</span>
								)}
								<span style={{ fontWeight: 400, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>&nbsp;&nbsp;{ewtStore.initialized && ewtStore.currentRoundID && ewtStore.rounds[ewtStore.currentRoundID] && ewtStore.rounds[ewtStore.currentRoundID].name}</span>
								{!ewtStore.org && <b>EWT</b>}
							</div>
						</div>
						<div style={{ margin: 0, padding: 0, flexShrink: 0 }}>
							<Dropdown
								placement="bottomRight"
								getPopupContainer={() => document.body}
								overlayStyle={{ maxWidth: '90vw' }}
								menu={{ items: menuItems, onClick: handleMainMenuClick, style: { fontSize: 26 } }}
								trigger={['click']}
							>
								<MenuOutlined style={{padding:5,fontSize:26,color:theme.navy}}/>
							</Dropdown>
						</div>
					</div>
					{ewtStore.showView === "MV" &&
					<> 
						<div className="flexGrow flexColumn appContent">
							{ewtStore.initialized && ewtStore.currentView === 'chats' && (
								<Suspense fallback={null}>
									<Chat mode="pics"></Chat>
								</Suspense>
							)}
							<div className="flexGrow flexColumn" style={{display:ewtStore.currentView === 'leaderboard'?'flex':'none', width: '100%', flex: 1, minHeight: 0, alignItems: 'stretch'}}>
								<Leaderboard></Leaderboard>
							</div>
							{!ewtStore.fanMode && <div className="flexGrow flexColumn" style={{ display: ewtStore.currentView === 'scoring' ? '' : 'none', width: '100%', minHeight: 0, alignItems: 'stretch' }}>
								{ewtStore.initialized && (!ewtStore.currentRoundID || ewtStore.course) && <Scoring></Scoring>}
							</div>}
						</div>
						<div className="noselect flexRow appTabBar">
							<div className={`menuDiv ${ewtStore.currentView==='leaderboard' ? "activeMenu" : ""}`} onClick={() => ewtStore.currentView = 'leaderboard'}><TrophyOutlined style={{width:30}}/>Cup</div>
							{!ewtStore.fanMode && <div className={`menuDiv ${ewtStore.currentView==='scoring' ? "activeMenu" : ""}`} onClick={() => ewtStore.currentView = 'scoring'}><EditOutlined style={{width:30}}/>Score</div>}
							<div className={`menuDiv ${ewtStore.currentView==='chats' ? "activeMenu" : ""}`} onClick={() => {ewtStore.unread["chats"] = false;ewtStore.currentView = 'chats'}}>
								<CommentOutlined style={{width:30,color:ewtStore.unread["chats"] && ewtStore.currentView !== 'chats' ? theme.brandRed : undefined}} />ED Talk
							</div>
							{false && <div className={`menuDiv ${ewtStore.currentView==='pics' ? "activeMenu" : ""}`} onClick={() => {ewtStore.unread["pics"] = false;ewtStore.currentView = 'pics'}}>
								<CameraOutlined  style={{width:30,color:ewtStore.unread["pics"]?'red':''}}/>Pics
							</div>}
						</div>
					</>
					}
					{ewtStore.showView === "SETUP" && (
						<Suspense fallback={null}>
							<Setup></Setup>
						</Suspense>
					)}
					{ewtStore.showView === "photo" && (
						<Suspense fallback={null}>
							<PlayerPhoto gallery={ewtStore.gallery}></PlayerPhoto>
						</Suspense>
					)}
				</div>
				{ewtStore.correctScore && <CorrectScore></CorrectScore>}
				{ewtStore.showPlayerCard && <PlayerCard player={ewtStore.showPlayerCard}></PlayerCard>}
				{ewtStore.showPlayerEdit && ewtStore.editPlayer && (
					<PlayerDetails
						key={ewtStore.playerEditKey}
						open={ewtStore.showPlayerEdit}
						player={ewtStore.editPlayer}
						hideModal={() => ewtStore.closePlayerEdit()}
						savePlayer={async (player) => {
							await ewtStore.savePlayer(player);
							ewtStore.closePlayerEdit();
							if (ewtStore.playersListRefresh) {
								await ewtStore.playersListRefresh();
							}
						}}
					/>
				)}
				{ewtStore.editRounds && <RoundMaint></RoundMaint>}
				<Modal
					className={ewtModalClass}
					title={<div style={{width:'100%'}}>
							<div className="flexRow" style={{marginBottom:20}}>
								{ewtStore.course && ewtStore.course.name}&nbsp;&nbsp;
							</div>
							<RoundSelector roundID={this.state.courseCardRoundID} handleEvent={this.roundChanged}></RoundSelector></div>}
					open={ewtStore.showCourseCard}
					bodyStyle={{margin:0,padding:0,height:ewtStore.windowHeight - 160,overflow:'hidden',display:'flex',flexDirection:'column'}}
					style={modalStyle}
					closable={true}
					onCancel={() => ewtStore.showCourseCard = false}
					width={ewtStore.windowWidth}
					footer={null}
					>
					<CourseCard roundID={this.state.courseCardRoundID}></CourseCard>
				</Modal>
				<Modal
					className={ewtModalClass}
					title={<div style={{width:'100%'}}>
							<div className="flexRow">
								{ewtStore.course && ewtStore.course.name}&nbsp;&nbsp;
								{ewtStore.currentRoundID && ewtStore.rounds[ewtStore.currentRoundID] && ewtStore.rounds[ewtStore.currentRoundID].name}
							</div>
						</div>}
					open={ewtStore.showTieBreaker}
					bodyStyle={{margin:0,padding:0,height:ewtStore.windowHeight - 125,overflow:'hidden',display:'flex',flexDirection:'column'}}
					style={modalStyle}
					closable={true}
					onCancel={() => ewtStore.showTieBreaker = false}
					width={ewtStore.windowWidth}
					footer={null}
					>
					<CourseCard tieBreakerMode={true}></CourseCard>
				</Modal>
				<Modal
					className={ewtModalClass}
					title="Select Tournament"
					open={ewtStore.selectTournament}
					bodyStyle={{margin:0,padding:0,height:ewtStore.panelHeight+70}}
					style={modalStyle}
					closable={true}
					onCancel={() => ewtStore.selectTournament = false}
					width={300}
					footer={null}
					>
					<div style={{marginLeft:16,marginTop:16,marginRight:16}}>
						{ewtStore.player && ewtStore.player.admin && (
							<div
								style={{ cursor: 'pointer', fontSize: 20, marginBottom: 15, color: theme.brandBlue, fontWeight: 500 }}
								onClick={this.openAddTournament}
							>
								<PlusOutlined /> Add Tournament
							</div>
						)}
						{ewtStore.playerFullTournamentsLoading && (
							<div style={{ fontSize: 20, padding: 10, color: theme.slate }}>
								<SyncOutlined spin /> Loading...
							</div>
						)}
						{ewtStore.initialized && ewtStore.getSelectTournamentList().map((tournament,index) => {
							return (
								<div key={index} className="flexRow ewtModalListItem" onClick={() => {
									ewtStore.showPlayerCard = null;
									ewtStore.setTournament(tournament.id, null, true);
									ewtStore.selectTournament = false;
								}}>
									<div className="flexGrow">{tournament.name}</div>
									{ewtStore.player && ewtStore.player.admin && (
										<EditFilled
											onClick={(e) => { e.stopPropagation(); this.openEditTournament(tournament); }}
											style={{ fontSize: 20, padding: 4, color: theme.brandBlue }}
										/>
									)}
								</div>
							)
						})}
					</div>
				</Modal>
				<DataTournamentEdit
					open={this.state.showTournamentEdit}
					hideModal={this.closeTournamentEdit}
					tournament={this.state.selectedTournament}
				/>
				<Modal
					className={ewtModalClass}
					title={`Hole Map #${ewtStore.showHole ? ewtStore.showHole : ''}`}
					open={ewtStore.showHole != null}
					onCancel={() => {ewtStore.holeMapURL=null;ewtStore.showHole = null}}
					bodyStyle={{margin:0,padding:0,maxHeight:window.innerHeight - 155,overflow:'auto',zIndex:999}}
					style={{ ...modalStyle, zIndex: 99 }}
					width={ewtStore.windowWidth}
					closable={true}
					footer={null}
					>
						<img className="fullImage" src={ewtStore.holeMapURL} style={{maxWidth:'100%',maxHeight:window.innerHeight - 175,height:'auto',display:'block',margin:'0 auto'}} alt=""></img>
				</Modal>
				<Modal
					className={ewtModalClass}
					title={`Course Map ${ewtStore.course ? ewtStore.course.name : ''}`}
					open={ewtStore.showCourseMap}
					onCancel={() => ewtStore.showCourseMap = false}
					bodyStyle={{margin:0,padding:0,height:ewtStore.windowHeight - 105,overflow:'auto',zIndex:999}}
					style={{ ...modalStyle, zIndex: 99 }}
					width={ewtStore.windowWidth}
					closable={true}
					footer={null}
					>
						<img className="fullImage" src={ewtStore.courseMapURL} style={{maxWidth:'100%',maxHeight:ewtStore.windowHeight - 125,height:'auto',display:'block',margin:'0 auto'}} alt="Loading"></img>
				</Modal>
				{ewtStore.showPairings && <Modal
					className={ewtModalClass}
					title="Pairings"
					open={ewtStore.showPairings}
					onCancel={() => ewtStore.showPairings=false}
					bodyStyle={{margin:0,padding:0,height:ewtStore.windowHeight - 105,overflow:'hidden',display:'flex',flexDirection:'column',zIndex:999}}
					style={{ ...modalStyle, zIndex: 99 }}
					closable={true}
					footer={null}
					>
						<Pairings all={true}></Pairings>
				</Modal>}
				{ewtStore.showPlayers && <Modal
					className={ewtModalClass}
					title="Players"
					open={ewtStore.showPlayers}
					onCancel={() => ewtStore.showPlayers=false}
					bodyStyle={{margin:0,padding:0,height:ewtStore.windowHeight - 105,overflow:'hidden',display:'flex',flexDirection:'column',zIndex:999}}
					style={{ ...modalStyle, zIndex: 99 }}
					closable={true}
					footer={null}
					>
						<Players></Players>
				</Modal>}
				{ewtStore.showItinerary && <Modal
					className={ewtModalClass}
					title="Weekend Schedule"
					open={ewtStore.showItinerary}
					onCancel={() => ewtStore.showItinerary = false}
					bodyStyle={{margin:0,padding:0,height:ewtStore.windowHeight - 105,overflow:'hidden',display:'flex',flexDirection:'column',zIndex:999}}
					style={{ ...modalStyle, zIndex: 99 }}
					closable={true}
					footer={null}
					>
						<Itinerary/>
				</Modal>}
		</div>
		</div>
	  );
	}
});


export default MainView;